import apiSettings from './api.settings'

const DEV_MODE = process.env.NODE_ENV === 'development'

const gtmId = process.env.REACT_APP_GTM_ID
const sentryDSN = process.env.REACT_APP_SENTRY_DSN
const environment = process.env.REACT_APP_ENVIRONMENT
const appTitle = process.env.REACT_APP_TITLE
const intercomId = process.env.REACT_APP_INTERCOM_ID
//
//─── ZAPIER INTEGRATION SETTINGS ────────────────────────────────────────────────────────────
//
const zapier = {
  scriptSrc: process.env.REACT_APP_ZAPIER_SCRIPT,
  styleSrc: process.env.REACT_APP_ZAPIER_STYLE,
  tutorial: process.env.REACT_APP_ZAPIER_TUTORIAL,
  blogPost: process.env.REACT_APP_ZAPIER_BLOG_POST,
  clientId: 'UCJG15nZCwbfVg49GZq7k878IX5y8CpulLDr5vRX',
}

//
// ─── ASSETS SETTINGS ────────────────────────────────────────────────────────────
//
const embedAbleFormRendererSettings = {
  cssURL: `${apiSettings.baseUrl}/istatic/css/main.css`,
  jsURL: `${apiSettings.baseUrl}/istatic/js/main.js`,
  widgetBundle: `${apiSettings.npsWidgetDomain}/script.js`,
  chatbotBundle: `${apiSettings.chatbotWidgetDomain}/script.js`,
  appUiBundle: `${apiSettings.appUiDomain}/script.js`,
  customCssId: 'custom-css',
}

const embedAbleScriptUrl = embedAbleFormRendererSettings.jsURL
const embedAbleCssUrl = embedAbleFormRendererSettings.cssURL
const embedAbleWidgetUrl = embedAbleFormRendererSettings.widgetBundle
const embedAbleChatbotUrl = embedAbleFormRendererSettings.chatbotBundle
const embedAbleAppUiUrl = embedAbleFormRendererSettings.appUiBundle

const customFaviconsRoot = process.env.REACT_APP_FAVICONS_ROOT ?? ''

//
// ─── DOM ELEMENTS SETTINGS ──────────────────────────────────────────────────────
//

// settings for loading embedded formz
const wrapperElementId = 'formz-wrapper'
const wrapperElementDataAttribute = 'formz-slug'
const wrapperElementTypeAttribute = 'formz-type'

//
// ─── LOCAL STORAGE ──────────────────────────────────────────────────────────────
//

const localStorageKey = 'formz-admin-auth-data'
const sessionStorageKeyForClient = 'formz-client-auth-data'
const singleSubmitFormInitialDataKey = 'formz-submit-initial-data'
const ACTIVE_WORKSPACE_STORAGE_KEY = 'active-workspace'

export const customFonts = {
  latin: process.env.REACT_APP_LATIN_FONT_SRC_URL,
  farsi: process.env.REACT_APP_FARSI_FONT_SRC_URL,
}

const assetSettings = {
  DEV_MODE,
  gtmId,
  sentryDSN,
  environment,
  embedAbleScriptUrl,
  embedAbleCssUrl,
  embedAbleWidgetUrl,
  embedAbleChatbotUrl,
  embedAbleAppUiUrl,
  wrapperElementId,
  wrapperElementDataAttribute,
  wrapperElementTypeAttribute,
  localStorageKey,
  sessionStorageKeyForClient,
  singleSubmitFormInitialDataKey,
  embedAbleFormRendererSettings,
  zapier,
  appTitle,
  intercomId,
  ACTIVE_WORKSPACE_STORAGE_KEY,
  customFaviconsRoot,
  customFonts,
}
export default assetSettings
